<template>
  <div class="address-map">
    <loader
      v-if="loading"
      absolute
    />
    <transition name="fade">
      <map-block
        v-if="addressCoordinates"
        :center="mapCenter"
        :zoom="mapZoom"
        :polygons="filteredPolygons"
        :loading="loading"
      >
        <address-marker
          v-if="addressCoordinates"
          :latitude="latitude"
          :longitude="longitude"
        />
      </map-block>
    </transition>
  </div>
</template>

<script>
  import MapBlock from '@/components/geo/couriers-map/MapBlock.vue'
  import { mapGetters } from 'vuex'
  import _ from 'lodash'
  import AddressMarker from '@/components/order-processing/order-components/address-window/AddressMarker.vue'
  import Loader from '@/components/loader/Loader.vue'

  export default {
    name: 'AddressMap',
    components: { Loader, AddressMarker, MapBlock },
    props: {
      loading: {
        type: Boolean,
        default: false,
      },
      latitude: {
        type: [String, Number],
        default: null,
      },
      longitude: {
        type: [String, Number],
        default: null,
      },
      filialId: {
        type: Number,
        default: null,
      },
    },
    data () {
      return {
      }
    },
    computed: {
      ...mapGetters({
        polygons: 'polygons/getPolygons',
      }),
      mapCenter () {
        return this.addressCoordinates || [55.7558, 37.6176].join(',')
      },
      addressCoordinates () {
        return this.latitude && this.longitude ? [this.latitude, this.longitude].join(',') : null
      },
      mapZoom () {
        return this.addressCoordinates ? 15 : 10
      },
      filteredPolygons () {
        return this.polygons
          .filter(polygon => !this.filialId || polygon.filialId === this.filialId)
      },
    },
    created () {
      if (_.isEmpty(this.polygons)) {
        this.loadPolygons()
      }
    },
    methods: {
      async loadPolygons () {
        await this.$store.dispatch('polygons/getPolygonsFromApi')
      },
    },
  }
</script>

<style scoped lang="less">
.address-map {
  position: relative;
  width: 100%;
  height: calc(100vh - 700px);
  min-height: 400px;
  max-height: 40vh;
}
</style>
